"use strict";
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("./state");
var navigation_1 = __importDefault(require("./components/navigation"));
var controlButtons_1 = __importDefault(require("./components/controlButtons"));
var stepPanes_1 = __importDefault(require("./components/stepPanes"));
var advisor_1 = __importDefault(require("./components/advisor"));
var wizardStateManager_1 = __importDefault(require("./components/wizardStateManager"));
var filtering_1 = __importDefault(require("./components/filtering"));
var formEventHandlers_1 = __importDefault(require("./components/formEventHandlers"));
var wizardPresentation_1 = __importDefault(require("./components/wizardPresentation"));
var modalsHandler_1 = __importDefault(require("./components/modalsHandler"));
exports.default = (function () {
    var advisorWizardContainer = document.querySelector('[data-advisor]');
    if (!advisorWizardContainer) {
        return false;
    }
    // Initialize the Navigation
    var navButtons = Array.from(document.querySelectorAll('[data-advisor-nav-button]'));
    if (navButtons) {
        state_1.setState({ totalSteps: navButtons.length });
        navigation_1.default(navButtons);
    }
    var controlButtons = Array.from(document.querySelectorAll('[data-advisor-button]'));
    if (controlButtons) {
        controlButtons_1.default(controlButtons);
    }
    var stepPanes = Array.from(document.querySelectorAll('[data-advisor-step]'));
    if (stepPanes) {
        stepPanes_1.default(stepPanes);
        state_1.setState({ activePaneElement: stepPanes[0] });
        state_1.setState({ activeStep: 1 });
    }
    var advisorCards = Array.from(document.querySelectorAll('.AdvisorCard.mix'));
    if (advisorCards) {
        var parsedAdvisors = advisorCards.map(advisor_1.default);
        state_1.setState({ advisors: parsedAdvisors });
        state_1.setState({ matchingAdvisors: parsedAdvisors });
        // TODO: Refactor this function out of this file
        var consolidatedLocations = parsedAdvisors.reduce(function (locations, advisor) {
            var offices = advisor.officeLocations;
            var updatedLocationArray = locations.concat(offices);
            updatedLocationArray = updatedLocationArray.filter(function (item, index) { return (updatedLocationArray.indexOf(item) == index); });
            return updatedLocationArray;
        }, []);
        state_1.setState({ advisorOffices: consolidatedLocations });
    }
    //Modal Wizard Set Zip
    var zipInput = document.querySelector('input[name="zip-code"]');
    var zipForm = document.querySelector('input[name="your-zip"]');
    if (zipInput && zipForm) {
        zipInput.addEventListener("change", function (e) {
            zipForm.value = zipInput.value;
        });
    }
    function singleRadial(fieldset, radios, formfield) {
        if (radios) {
            radios.forEach(function (radio) {
                if (radio.checked) {
                    formfield.value = radio.value;
                }
            });
        }
        if (fieldset && formfield) {
            fieldset.addEventListener("change", function (e) {
                formfield.value = '';
                if (radios) {
                    radios.forEach(function (radio) {
                        if (radio.checked) {
                            formfield.value = radio.value + ' ' + formfield.value;
                        }
                    });
                }
            });
        }
    }
    //Modal Wizard Set Location
    var locationInput = document.querySelector('#locations');
    var locationRadios = Array.from(document.querySelectorAll('input[name="location_options"]'));
    var locationForm = document.querySelector('input[name="location-preference"]');
    singleRadial(locationInput, locationRadios, locationForm);
    if (document.querySelector('#locations')) {
        document.getElementById("location_optionsshow-all-matching-advisors-i%e2%80%99m-okay-with-virtual-meetings").click();
    }
    if (zipInput) {
        zipInput.addEventListener("change", function (e) {
            if (locationRadios) {
                locationRadios.forEach(function (radio) {
                    if (radio.checked) {
                        radio.click();
                    }
                });
            }
        });
    }
    //Modal Wizard Set Income
    var incomeInput = document.querySelector('#incomes');
    var incomeRadios = Array.from(document.querySelectorAll('input[name="income_options"]'));
    var incomeForm = document.querySelector('input[name="your-income"]');
    singleRadial(incomeInput, incomeRadios, incomeForm);
    //Modal Wizard Set Assets
    var assetsInput = document.querySelector('#assets');
    var assetsRadios = Array.from(document.querySelectorAll('input[name="asset_options"]'));
    var assetsForm = document.querySelector('input[name="your-assets"]');
    singleRadial(assetsInput, assetsRadios, assetsForm);
    //Modal Wizard Set Age
    var ageInput = document.querySelector('#ages');
    var ageRadios = Array.from(document.querySelectorAll('input[name="age_options"]'));
    var ageForm = document.querySelector('input[name="your-age"]');
    singleRadial(ageInput, ageRadios, ageForm);
    //Modal Wizard Set Occupation
    var occupationInput = document.querySelector('#occupations');
    var occupationRadios = Array.from(document.querySelectorAll('input[name="occupation_options"]'));
    var occupationForm = document.querySelector('input[name="your-occupation"]');
    singleRadial(occupationInput, occupationRadios, occupationForm);
    //Modal Wizard Set Goals
    var goalInput = document.querySelector('#goals');
    var goalRadios = Array.from(document.querySelectorAll('input[name="goal_options"]'));
    var goalForm = document.querySelector('input[name="your-goals"]');
    singleRadial(goalInput, goalRadios, goalForm);
    wizardStateManager_1.default();
    filtering_1.default();
    formEventHandlers_1.default();
    wizardPresentation_1.default();
    modalsHandler_1.default();
});
